import React from "react";
import OptionsPanelFooter from "./OptionsPanelFooter";
import { type ShortcutTypes } from "../Shortcuts/models";
import ShortcutsApp from "../Shortcuts/app";
import OptionsPanel from "../panels/OptionsPanel";

interface Props {
  title?: string | React.ReactNode
  data?: server.dto.OptionsPanelDataV2
  links: OptionLink[]
  shortcutOrder?: ShortcutTypes[]
}

interface OptionLink {
  text: string
  visible: boolean
  href?: string
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

const GeneralOptionsPanel = (props: React.PropsWithChildren<Props>) => {
  const links = props.links.filter(link => link.visible);

  return <OptionsPanel title={props.title || RESX.OptionsPanel.Options}>
    <div className="">
      <div className="menugroup">
        {links.map(link =>
          <div className="s1_menuitem" key={link.text}>
            <div className="s1_menulink">
              <a href={link.href} onClick={link.onClick}>{link.text}</a>
            </div>
          </div>
        )}
      </div>
    </div>

    {props.children}

    {(props.data && props.data.recordCount > 1) && <OptionsPanelFooter
      optionsPanelData={props.data}
    />}

    {props.shortcutOrder && <div>
      <ShortcutsApp
        shortcutOrder={props.shortcutOrder}
      />
    </div>}

  </OptionsPanel>;
};

export default GeneralOptionsPanel;